import { useCallback, useEffect, useState } from 'react'
import { ConfirmModal } from 'components/dialog/ModalTemplate'
import classNames from 'classnames'
import MixedBasicPreview from 'features/creative/preview/MixedBasicPreview'
import MixedCreativePreviewList from 'features/creative/preview/MixedCreativePreviewList'
import AssetPreview from 'features/creative/preview/AssetPreview'
import { Modal } from 'components/dialog/Modals'
import { ASSET_COMBINATIONS, BizChannelTypes } from 'features/Codes'
import Loading from 'components/loading/Loading'
import NoneAnchor from 'components/NoneAnchor'
import { useDispatch, useSelector } from 'react-redux'
import { hideCreativePreview } from 'features/dashboard/operation/creativePreview/creativePreviewSlice'
import MixedTalkChannelPreview from '../../../creative/preview/MixedTalkChannelPreview'

const CreativePreviewModal = () => {
  const dispatch = useDispatch()
  const {
    isLoading,
    isShowPreview,
    channel,
    channel: { bizChannelType, siteUrl = {} },
    creative,
  } = useSelector(state => state.dashboard.operation.creativePreview)
  const [isMobileView, setMobileView] = useState(true)
  const [validCombinations, setValidCombinations] = useState([])

  useEffect(() => {
    if (creative.assets) {
      setValidCombinations(
        (isMobileView
          ? ASSET_COMBINATIONS.mobile
          : ASSET_COMBINATIONS.pc
        ).filter(comb =>
          creative
            ? comb.every(type =>
                creative.assets.find(asset => asset.type.name === type)
              )
            : false
        )
      )
    }
  }, [creative, isMobileView])
  useEffect(() => () => dispatch(hideCreativePreview()), [dispatch])

  const handleClose = useCallback(
    () => dispatch(hideCreativePreview()),
    [dispatch]
  )

  return (
    <Modal
      on={isShowPreview}
      className={
        bizChannelType === BizChannelTypes.TALK_CHANNEL
          ? 'preview_layer2'
          : 'preview_layer'
      }>
      <ConfirmModal
        title="소재 미리보기"
        showCancelBtn={false}
        handleClose={handleClose}
        onConfirm={handleClose}>
        {isLoading ? (
          <div style={{ height: 263 }}>
            <Loading />
          </div>
        ) : (
          <div className="view_material">
            <div className="view_tit">
              <strong className="tit_view">미리보기</strong>
              <ul className="tab_view">
                {bizChannelType === BizChannelTypes.TALK_CHANNEL ? (
                  <li className="on">
                    <NoneAnchor className="link_tab">모바일 전용</NoneAnchor>
                  </li>
                ) : (
                  <>
                    <li className={classNames({ on: isMobileView })}>
                      <NoneAnchor
                        className="link_tab"
                        onClick={() => setMobileView(true)}>
                        모바일
                      </NoneAnchor>
                    </li>
                    <li className={classNames({ on: !isMobileView })}>
                      <NoneAnchor
                        className="link_tab"
                        onClick={() => setMobileView(false)}>
                        PC
                      </NoneAnchor>
                    </li>
                  </>
                )}
              </ul>
            </div>
            <div className="layer_scroll">
              {bizChannelType === BizChannelTypes.TALK_CHANNEL ? (
                <MixedTalkChannelPreview
                  channel={channel}
                  creative={creative}
                />
              ) : (
                <>
                  <div
                    className={classNames('view_detail', {
                      view_mo: isMobileView,
                      view_pc: !isMobileView,
                    })}>
                    <em className="view_type">기본</em>
                    <MixedBasicPreview
                      creative={creative}
                      siteUrl={siteUrl}
                      isMobileView={isMobileView}
                    />
                  </div>
                  {validCombinations.length > 0 && (
                    <MixedCreativePreviewList
                      combinations={validCombinations}
                      creative={creative}
                      siteUrl={siteUrl}
                      isMobileView={isMobileView}
                    />
                  )}
                  {creative.assets.length > 0 && (
                    <AssetPreview
                      creative={creative}
                      siteUrl={siteUrl}
                      isMobileView={isMobileView}
                    />
                  )}
                </>
              )}
            </div>
          </div>
        )}
      </ConfirmModal>
    </Modal>
  )
}

export default CreativePreviewModal
